<template>
  <div class="bill-recharge-record">
    <div style="height: calc(100% - var(--pageHeight))">
      <TableCom
        :tableList="tableList"
        :tableProps="tableProps"
      ></TableCom>
      <!-- <el-scrollbar height="100%">
        <div class="bill-Pay-item"
          v-for="(item, index) in tableList"
          :key="index"
        >
          <div class="bill-Pay-item-number ellipsis"
            :title="item['orderNumber']"
          >{{ item['orderNumber'] }}</div>
          <div class="bill-Pay-item-time">{{ item['rechargeTime'] }}</div>
          <div class="bill-Pay-item-time">{{ item['paymentTime'] }}</div>
          <div class="bill-Pay-item-integral">{{ item['integral'] }}</div>
          <div class="bill-Pay-item-priceDiscount">{{ item['priceDiscount'] }}%</div>
          <div class="bill-Pay-item-amount">{{ item['amount'] }}</div>
          <div class="bill-Pay-item-statusType">{{ item['statusType'] }}</div>
          <div class="bill-Pay-item-userName">{{ item['userName'] }}</div>
        </div>
      </el-scrollbar> -->
    </div>
    <div
      class="page-body"
    >
      <Pagination 
        @pageChange="pageChange"
        :total="total"
        v-model:page="listQuery.page"
        v-model:limit="listQuery.limit"
      />
    </div>
  </div>

</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import Pagination from '@/components/Pagination';
import TableCom from '@/components/TableCom';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);
const tableList = ref([]);
const tableNumber = (number)=>{
  return (listQuery.page-1) * listQuery.limit + number;
}
const tableProps = ref([
  { label: '序号', fun: tableNumber, fixed: true, width: '80px', },
  { label: '订单编号', prop: 'orderNumber', width: '200px', icon: 'copy' },
  { label: '创建时间', prop: 'rechargeTime', width: '160px' },
  { label: '支付时间', prop: 'paymentTime', width: '160px' },
  { label: '积分', prop: 'integral', },
  { label: '折扣', prop: 'priceDiscount', fun: (target)=>{
      return `${target['priceDiscount']}%`
    } 
  },
  { label: '支付金额（元）', prop: 'amount', },
  { label: '创建用户', prop: 'userName', },
  { label: '状态', prop: 'statusType', },
])

let total = ref(0),
    listQuery = reactive({
      page: 1,
      limit: 20,
    });
// 分页器change
const pageChange = ()=>{
  selectList();
}

// const selectList = ()=>{
//   getRechargeRecord(listQuery).then(res=>{
//     if(res.data.code == 1004){
//       tableList.value = res.data.data;
//       total.value = res.data.count;
//     }
//   }).catch(err=>{
//     console.log(err);
//   });
// }

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  selectList();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.bill-recharge-record{
  height: 100%;
  padding: 5px;
  .bill-Pay-item{
    width: 100%;
    height: 40px;
    background-color: var(--backgroundColor_25);
    margin-bottom: 8px;
    &:nth-last-child(1){
      margin-bottom: 0;
    }
    display: flex;
    align-items: center;
    div{
      text-align: center;
    }
    .bill-Pay-item-number{
      width: 200px;
    }
    .bill-Pay-item-time{
      width: 200px;
    }
    .bill-Pay-item-integral{
      width: 100px;
    }
    .bill-Pay-item-priceDiscount{
      width: 50px;
    }
    .bill-Pay-item-amount{
      width: 100px;
    }
    .bill-Pay-item-statusType{
      width: 100px;
    }
    .bill-Pay-item-userName{
      width: 100px;
    }
  }
}
</style>